import { Component, computed, EventEmitter, Input, OnInit, Output, Signal } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { Store } from '@ngrx/store';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';
import { ApplicantForm } from '../../forms/applicant.form';
import { ApplicantAppEntityApplicantWrite } from '../../../../../../../openapi';
import { UserDetails } from '../../../../../../../store/reducers/user-details.reducer';
import { selectUser } from '../../../../../../../store/selectors/user-details.selectors';
import { SessionService } from '../../../../../../../services/ssession.service';
import {
  ApplicantCorrespondenceFormComponent
} from '../applicant-correspondence-form/applicant-correspondence-form.component';
import { selectEntityTypes } from '../../../../../../../store/selectors/application.selectors';

@Component({
  selector: 'app-natural-person-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    NgxMaskDirective,
    ApplicantCorrespondenceFormComponent
  ],
  templateUrl: './natural-person-form.component.html'
})
export class NaturalPersonFormComponent implements OnInit {

  @Input()
  public entityTypeCode: string | undefined;

  private entityTypeId: Signal<string> = computed(() => {
    const types = this.store$.selectSignal(selectEntityTypes);
    return types().filter(v => v.code === this.entityTypeCode).at(0)?.id || '';
  });

  @Input()
  public autoFillButtons = true;

  @Input()
  public form: ApplicantForm | undefined;

  @Input()
  public showCancel: boolean = true;

  @Output()
  public onCancel = new EventEmitter();

  @Output()
  public onSubmit = new EventEmitter<ApplicantAppEntityApplicantWrite>();

  @Input()
  public edit = false;

  public user: Signal<UserDetails | null> = this.store$.selectSignal(selectUser);

  public validators = Validators;

  constructor(private store$: Store) {
  }

  public onPastDataFromPortal(): void {
    this.form?.readApplicantDataFromPortal(this.user());
  }

  public onPastDataFromLoginGov(): void {
    this.form?.readApplicantDataFromGovPl(SessionService.GetTokenData());
  }

  public submit(): void {
    if (this.form?.valid) {
      this.onSubmit.emit(this.form.toWriteModel());
      this.form.reset({ applicantType: this.entityTypeId() });
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public cancel(): void {
    this.onCancel.emit();
    this.form?.reset({ applicantType: this.entityTypeId() });
  }

  public ngOnInit(): void {
    this.form?.applicantType.setValue(this.entityTypeId());

    this.form?.name.disable();
    this.form?.nip?.disable();

    this.form?.firstName.enable();
    this.form?.lastName.enable();
    this.form?.pesel?.enable();

    this.form?.country.enable();
    this.form?.voivodeship.enable();
    this.form?.county.enable();
    this.form?.municipality.enable();
  }
}
